/**
 * Video thumbnail grid for the "Music We Love" page.
 * Renders YouTube thumbnail images in a responsive grid with hover effects,
 * play indicator overlays, and a ring highlight for the currently selected video.
 */


interface VideoItem {
  id: string;
  title: string;
  artist?: string;
  category?: string;
}

interface VideoStackProps {
  videos: VideoItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

const VideoStack = ({ videos, selectedId, onSelect }: VideoStackProps) => {
  return (
    <div className="space-y-6">
      
      
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {videos.map((video, index) => (
          <button
            key={video.id}
            onClick={() => onSelect(video.id)}
            className={`
              group relative overflow-hidden rounded-sm text-left
              transition-all duration-300
              ${selectedId === video.id 
                ? 'ring-2 ring-foreground ring-offset-2 ring-offset-background scale-[1.02]' 
                : 'hover:scale-[1.03]'
              }
            `}
          >
            {/* Thumbnail */}
            <div className="relative aspect-video overflow-hidden bg-muted rounded-sm">
            <img
                src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                alt={video.title}
                loading="lazy"
                width={320}
                height={180}
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {/* Play indicator overlay */}
              <div className="absolute inset-0 flex items-center justify-center bg-background/40 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-10 h-10 rounded-full bg-foreground/90 flex items-center justify-center">
                  <div className="w-0 h-0 border-t-[6px] border-t-transparent border-l-[10px] border-l-background border-b-[6px] border-b-transparent ml-1" />
                </div>
              </div>
              {/* Selected indicator */}
              {selectedId === video.id && (
                <div className="absolute top-2 right-2 w-3 h-3 rounded-full bg-foreground animate-pulse" />
              )}
            </div>
            
            {/* Video info */}
            <div className="mt-2">
              <p className="text-sm font-medium text-foreground truncate">
                {video.title}
              </p>
              {video.artist && (
                <p className="text-xs text-muted-foreground truncate">
                  {video.artist}
                </p>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default VideoStack;